// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'
import { jwtDecode } from "jwt-decode"
import { clearRolesNotCheckedIn } from '@src/store/rolesNotCheckedIn/actions'

const config = useJwt.jwtConfig

// ** Handle User Login
export const handleLogin = data => {
  return dispatch => {

    data = {
      ...data,
      id: 1,
      fullName: data.name,
      username: data.name,
      avatar: data.picture,
      email: data.email,
      role: "admin",
      ability: [
          {
              action: "manage",
              subject: "all"
          }
      ],
      extras: {
          eCommerceCartItemsCount: 5
      }
    }

    dispatch({
      type: 'LOGIN',
      data,
      config,
      [config.storageTokenKeyName]: data[config.storageTokenKeyName],
      [config.storageRefreshTokenKeyName]: data[config.storageRefreshTokenKeyName]
    })

    const decoded = jwtDecode(data.accessToken)      
    if (decoded?.facilities?.length > 0) {    
      console.log('decoded.facilities[0]')    
      console.log(decoded.facilities[0])
      localStorage.setItem('currentFacility', JSON.stringify(decoded.facilities[0]))
    } else {
      localStorage.setItem('currentFacility', null)  
    }

    // ** Add to user, accessToken & refreshToken to localStorage
    localStorage.setItem('userData', JSON.stringify(data))
    localStorage.setItem(config.storageTokenKeyName, data.accessToken)
    localStorage.setItem(config.storageRefreshTokenKeyName, data.refreshToken)
  }
}

// ** Handle User Logout
export const handleLogout = () => {
  return dispatch => {
    dispatch(clearRolesNotCheckedIn())
    dispatch({ type: 'LOGOUT', [config.storageTokenKeyName]: null, [config.storageRefreshTokenKeyName]: null })

    // ** Remove user, accessToken & refreshToken from localStorage
    localStorage.removeItem('userData')
    localStorage.removeItem(config.storageTokenKeyName)
    localStorage.removeItem(config.storageRefreshTokenKeyName)
  }
}
